import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAdditionalOffer } from '../../common/api/clients/rfq.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useCreateAdditionalOffer = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createAdditionalOffer,
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: queries.requestsForQuotes.detail(variables.requestForQuoteId).queryKey,
            });
        },
    });
};
